// PLAY_LABEL_GLYPHS — generated by scripts/extract-glyphs.py. DO NOT hand-edit.
// Satoshi-Bold (700) glyph outlines, one <path> per letter, laid out with the
// logo's 0.04em tracking, y-flipped into SVG space (baseline at y=0). Coordinates
// are in font units (unitsPerEm=1000). Source font: Satoshi-Bold.woff2.
// Regenerate: scripts/doc-tools/extract-glyphs.py --name PLAY_LABEL_GLYPHS Spielen Play | npx prettier --parser babel

export const PLAY_LABEL_GLYPHS = {
  Spielen: {
    viewBox: "-40 -1010 3733 1250",
    glyphs: [
      {
        ch: "S",
        d: "M39 -527Q39 -623 111.5 -683.5Q184 -744 299 -744Q410 -744 476.0 -686.5Q542 -629 545 -530H417Q415 -577 383.0 -603.5Q351 -630 297 -630Q238 -630 202.5 -603.5Q167 -577 167 -531Q167 -456 256 -436L371 -411Q557 -371 557 -211Q557 -109 484.0 -48.0Q411 13 290 13Q173 13 102.0 -45.0Q31 -103 29 -201H157Q158 -155 193.0 -128.5Q228 -102 290 -102Q354 -102 391.5 -128.0Q429 -154 429 -200Q429 -273 344 -291L228 -317Q39 -358 39 -527Z",
      },
      {
        ch: "p",
        d: "M695.0 229V-494H808.0L816.0 -419Q838.0 -461 883.5 -485.0Q929.0 -509 986.0 -509Q1090.0 -509 1153.5 -439.0Q1217.0 -369 1217.0 -253Q1217.0 -135 1155.5 -61.0Q1094.0 13 986.0 13Q930.0 13 885.0 -8.0Q840.0 -29 817.0 -66V229ZM957.0 -97Q1021.0 -97 1057.5 -138.5Q1094.0 -180 1094.0 -247.0Q1094.0 -314 1057.0 -356.0Q1020.0 -398 957.0 -398.0Q894.0 -398 856.0 -356.0Q818.0 -314 818.0 -247.0Q818.0 -180 856.0 -138.5Q894.0 -97 957.0 -97Z",
      },
      {
        ch: "i",
        d: "M1415.0 -593Q1384.0 -593 1362.0 -614.5Q1340.0 -636 1340.0 -667.0Q1340.0 -698 1361.5 -719.0Q1383.0 -740 1415.0 -740Q1445.0 -740 1466.5 -719.0Q1488.0 -698 1488.0 -667.0Q1488.0 -636 1466.5 -614.5Q1445.0 -593 1415.0 -593ZM1354.0 0V-494H1476.0V0Z",
      },
      {
        ch: "e",
        d: "M1863.0 13Q1753.0 13 1683.0 -59.5Q1613.0 -132 1613.0 -247Q1613.0 -363 1681.5 -436.0Q1750.0 -509 1859.0 -509Q1970.0 -509 2035.5 -440.5Q2101.0 -372 2101.0 -256V-219L1729.0 -218Q1743.0 -87 1865.0 -87Q1968.0 -87 1990.0 -160H2103.0Q2087.0 -79 2023.5 -33.0Q1960.0 13 1863.0 13ZM1860.0 -409Q1750.0 -409 1732.0 -296H1980.0Q1980.0 -347 1947.5 -378.0Q1915.0 -409 1860.0 -409Z",
      },
      { ch: "l", d: "M2362.0 0H2241.0V-744H2362.0Z" },
      {
        ch: "e",
        d: "M2751.0 13Q2641.0 13 2571.0 -59.5Q2501.0 -132 2501.0 -247Q2501.0 -363 2569.5 -436.0Q2638.0 -509 2747.0 -509Q2858.0 -509 2923.5 -440.5Q2989.0 -372 2989.0 -256V-219L2617.0 -218Q2631.0 -87 2753.0 -87Q2856.0 -87 2878.0 -160H2991.0Q2975.0 -79 2911.5 -33.0Q2848.0 13 2751.0 13ZM2748.0 -409Q2638.0 -409 2620.0 -296H2868.0Q2868.0 -347 2835.5 -378.0Q2803.0 -409 2748.0 -409Z",
      },
      {
        ch: "n",
        d: "M3249.0 0H3127.0V-494H3240.0L3250.0 -430Q3273.0 -467 3315.0 -488.0Q3357.0 -509 3408.0 -509Q3500.0 -509 3548.0 -455.0Q3596.0 -401 3596.0 -304V0H3474.0V-275Q3474.0 -336 3446.5 -367.0Q3419.0 -398 3370.0 -398Q3314.0 -398 3281.5 -362.0Q3249.0 -326 3249.0 -266Z",
      },
    ],
  },
  Play: {
    viewBox: "-40 -1010 2167 1250",
    glyphs: [
      {
        ch: "P",
        d: "M370 -252H209V0H81V-731H370Q480 -731 546.0 -665.5Q612 -600 612 -492Q612 -386 545.5 -319.0Q479 -252 370 -252ZM345 -617H209V-366H343Q408 -366 443.0 -399.0Q478 -432 478 -493Q478 -553 443.5 -585.0Q409 -617 345 -617Z",
      },
      { ch: "l", d: "M865.0 0H744.0V-744H865.0Z" },
      {
        ch: "a",
        d: "M1180.0 13Q1102.0 13 1056.5 -29.0Q1011.0 -71 1011.0 -141Q1011.0 -209 1058.5 -250.0Q1106.0 -291 1194.0 -298L1342.0 -309V-320Q1342.0 -414 1240.0 -414Q1186.0 -414 1157.0 -392.5Q1128.0 -371 1128.0 -332H1024.0Q1024.0 -412 1084.5 -460.5Q1145.0 -509 1246.0 -509.0Q1347.0 -509 1404.0 -455.0Q1461.0 -401 1461.0 -300V0H1354.0L1345.0 -73Q1329.0 -35 1283.5 -11.0Q1238.0 13 1180.0 13ZM1220.0 -79Q1277.0 -79 1310.0 -111.0Q1343.0 -143 1343.0 -200V-226L1240.0 -218Q1135.0 -208 1135.0 -146Q1135.0 -79 1220.0 -79Z",
      },
      {
        ch: "y",
        d: "M1578.0 229V127H1651.0Q1690.0 127 1712.5 113.0Q1735.0 99 1750.0 58L1764.0 21L1565.0 -494H1694.0L1821.0 -134L1955.0 -494H2081.0L1839.0 110Q1811.0 179 1770.5 209.5Q1730.0 240 1669.0 240Q1620.0 240 1578.0 229Z",
      },
    ],
  },
};
